import { isString, isStringArray } from "../type-guards";
export const StringErrorMessages = {
    default: `不正な形式です。`,
    notEqual: (v) => `${v}を入力してください。`,
    invalid: `文字列で入力してください`,
    length: (length) => `${length}文字で入力してください。`,
    max: (max) => `${max}文字以内で入力してください。`,
    min: (min) => `${min}文字以上で入力してください。`,
    oneOf: (oneOf) => `${oneOf.join(",")}のいずれかで入力してください。`,
    matches: `不正な入力形式です。`,
    key: `不正なキー形式です。`,
    email: `メールアドレス形式で入力してください。`,
    url: `URL形式で入力してください。`,
    uuid: `UUID形式で入力してください。`,
    hira: `ひらがなで入力してください。`,
    kana: `カタカナで入力してください。`,
    number: `数字で入力してください。`,
};
class BasePrimitiveValidator {
    errors;
    constructor(errors = []) {
        this.errors = errors;
    }
    validate() {
        return this.errors.length > 0 ? this.errors : undefined;
    }
    append(isError, newError) {
        if (!isError || newError === undefined) {
            return;
        }
        if (isString(newError)) {
            this.errors.push(newError);
        }
        if (isStringArray(newError)) {
            this.errors.push(...newError);
        }
    }
}
/**
 * @deprecated zod使おう。
 */
export class StringValidator extends BasePrimitiveValidator {
    v;
    isNotString;
    constructor(v) {
        super();
        this.v = v;
        this.isNotString = typeof v !== "string";
        this.append(this.isNotString, StringErrorMessages.default);
    }
    equals(v) {
        if (this.isNotString) {
            return this;
        }
        this.append(this.v !== v, StringErrorMessages.notEqual(v));
        return this;
    }
    length(length) {
        if (this.isNotString) {
            return this;
        }
        this.append(this.v.length !== length, StringErrorMessages.length(length));
        return this;
    }
    min(min) {
        if (this.isNotString) {
            return this;
        }
        this.append(this.v.length < min, StringErrorMessages.min(min));
        return this;
    }
    max(max) {
        if (this.isNotString) {
            return this;
        }
        this.append(this.v.length > max, StringErrorMessages.max(max));
        return this;
    }
    oneOf(matches) {
        if (!isStringArray(matches) || matches.length === 0) {
            throw new Error(`不正なバリデーションルールです。StringValidator.oneOf(${matches})`);
        }
        if (this.isNotString) {
            return this;
        }
        this.append(!matches.includes(this.v), StringErrorMessages.oneOf(matches));
        return this;
    }
    key() {
        const regExp = new RegExp(/[a-zA-Z0-9_]{1,32}/);
        this.append(!regExp.test(this.v), StringErrorMessages.key);
        return this;
    }
    match(match) {
        if (this.isNotString) {
            return this;
        }
        this.append(!match.test(this.v), StringErrorMessages.matches);
        return this;
    }
    hira() {
        const regExp = new RegExp(/^[\u3041-\u3096]+$/);
        this.append(!regExp.test(this.v), StringErrorMessages.hira);
        return this;
    }
    kana() {
        const regExp = new RegExp(/^[0-9\u30A0-\u30FF\s()]+$/);
        this.append(!regExp.test(this.v), StringErrorMessages.kana);
        return this;
    }
}
//# sourceMappingURL=string-validator.js.map